/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/search'>.
 * Не-exact: хвосты ловит соседний search/$.tsx. Поиск живёт на GET-параметре
 * ?query= (см. §3.1) — сериализация query сохраняется 1:1.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import SearchPage from '@routes/SearchPage';

export const Route = createFileRoute('/search/')({
  component: () => <CacheDataRoute component={SearchPage} path='/search' />
});
